import {Component, ElementRef, NgModule, NgZone, OnInit, ViewChild, Input} from '@angular/core';
import {Options} from "ngx-google-places-autocomplete/objects/options/options";
import {Events} from "../../../../../framework/providers/events";

declare var google;


@Component({
    selector: 'app-pick-address',
    templateUrl: './pick-address.component.html',
    styleUrls: ['./pick-address.component.scss'],
})
export class PickAddressComponent implements OnInit {
    // @ViewChild("placesRef") placesRef: GooglePlaceDirective;

    @ViewChild('map', null) mapElement: ElementRef;
    map: any;

    @ViewChild("search")
    public searchElementRef: ElementRef;

    @Input()
    myprefix;
    @Input()
    exTableData;
    @Input()
    extraData;
    @Input()
    tableData;

    latLng;
    address;

    formattedaddress = " ";

    options: Options = {
        bounds: undefined,
        fields: ['address_component'],
        strictBounds: false,
        types: ['address'],
        origin: undefined,
        componentRestrictions: undefined
    };

    constructor(public events: Events) {
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        // this.events.unsubscribe('showOnMap');
    }


    ngAfterViewInit() {
        return
        this.initMap(0, 0);
        // if (this.latLng) {
        //     this.showCord(this.latLng[0], this.latLng[1]);
        // } else {
        this.mapInitializer();
        // }
    }

    initMap(lat, lng) {
        return
        let latLng = new google.maps.LatLng(lat, lng);
        let mapOptions = {
            center: latLng,
            streetViewControl: true,
            zoom: 4,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
        ////console.log'init map!!');
    }

    handleAddressChange(address: any) {
        ////console.log"123");
        ////console.logaddress);
    }

    mapInitializer() {
        // if (!this.address)
        //     return;
        //
        // let me = this;
        // this.geocoder.geocode({'address': this.address}, function (results, status) {
        //     //console.log'map results:');
        //     //console.logresults);
        //     if (!results.length) {
        //         me.invalidMap = true;
        //         return
        //     }
        //     me.invalidMap = false;
        //     if (status == google.maps.GeocoderStatus.OK) {
        //         let lat = results[0].geometry.location['lat']();
        //         let lng = results[0].geometry.location['lng']();
        //
        //         // , results[0].geometry.location
        //         me.showCord(lat, lng);
        //
        //     } else {
        //         alert('Geocode was not successful for the following reason: ' + status);
        //     }
        // });
    }


}
